const initialState = null;

const getUserType = (state = initialState, action) => {
  switch (action.type) {
    case "GETUSERTYPE":
      return action.payload;
    default:
      return state;
  }
};

export default getUserType;
